import Link from "next/link";
import { Small } from "src/lib/components/salify-next-layout/default/components/Typography"; // GLOBAL CUSTOM COMPONENT

// ==============================================================
const NavLink2 = ({ url, color, title = "SHOP NOW", borderColor = "primary.600" }) => {
  return (
    <Link href={url}>
      <Small fontWeight="700" borderBottom={2} color={color} borderColor={borderColor}>
        {title}
      </Small>
    </Link>
  );
};

export default NavLink2;
